import { render, staticRenderFns } from "./Migration.vue?vue&type=template&id=2460480c&scoped=true"
import script from "./Migration.vue?vue&type=script&setup=true&lang=js"
export * from "./Migration.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Migration.vue?vue&type=style&index=0&id=2460480c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2460480c",
  null
  
)

export default component.exports